// Sanadat Management Permissions

export const SANADAT_INDEX = 55;
export const SANADAT_SHOW = SANADAT_INDEX;
export const SANADAT_CREATE = 56;
export const SANADAT_PRINT = 1220;
// Producing the document is one capability: download is gated by the print permission.
export const SANADAT_DOWNLOAD = SANADAT_PRINT;
